module.exports = __webpack_public_path__ + "dist/solution_2.0c511900.png";